module.exports = __webpack_public_path__ + "7baf7ed405504f20f254b343f541c70b.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/thumbnail/public/news/img1_1.jpg
// module id = 535
// module chunks = 0